import React, { useContext, useCallback } from 'react';
import ProductPageContext from '../../../contexts/ProductPageContext';
import OutfitImage from './OutfitImage';

const OutfitCard = ({
  products = [],
  brand,
}) => {
  const ProductPageState = useContext(ProductPageContext);
  const { activeProduct } = ProductPageState.collectionData || {};
  const { tmntData } = ProductPageState;

  const isSameAsActivePDP = useCallback((productId) => {
    if (!activeProduct) return false;
    return productId === activeProduct.productId;
  }, [activeProduct]);

  const triggerQuickview = (product) => {
    const { productId, collectionId } = product;
    document.dispatchEvent(new CustomEvent('quickview:mfe:openModal', {
      detail: {
        productId,
        collectionId,
        faceout: 'prod',
        type: 'default',
        analytics: 'stylitics',
      },
    }));
  };

  return (
    <div
      className="pdp-outfit-card"
      data-testid="pdp-outfit-card"
      data-items={products.length}
    >
      {products.map((product) => (
        <OutfitImage
          tmntData={tmntData}
          key={product.kicId}
          product={product}
          brand={brand}
          onQuickview={triggerQuickview}
          isDisabled={isSameAsActivePDP(product.productId)}
        />
      ))}
    </div>
  );
};

export default OutfitCard;
